import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const Investiture2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p0 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/0.webp`;
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/10.webp`;
    const p11 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/11.webp`;
    const p12 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/12.webp`;
    const p13 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/13.webp`;
    const p14 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/14.webp`;
    const p15 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/15.webp`;
    const p16 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/16.webp`;
    const p17 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/17.webp`;
    const p18 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/18.webp`;
    const p19 = `${config.base_image_url_2026}/home/events-activities/school-programs/investiture/19.webp`;
  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 2,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 2,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 2,
            cols: 1,
        }, {
            src: p5,
            source: p5,
            rows: 2,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 2,
            cols: 1,
        }, 
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 2,
            cols: 1,
        },
        {
          src: p10,
          source: p10,
          rows: 2,
          cols: 1,
        }, 
        {
        src: p11,
        source: p11,
        rows: 2,
        cols: 1,
       },
       {
        src: p12,
        source: p12,
        rows: 2,
        cols: 1,
       },
       {
        src: p13,
        source: p13,
        rows: 2,
        cols: 1,
       },
       {
        src: p14,
        source: p14,
        rows: 2,
        cols: 1,
       }, 
       {
        src: p15,
        source: p15,
        rows: 1.8,
        cols: 2,
       },
       {
        src: p16,
        source: p16,
        rows: 1.7,
        cols: 2,
       }, 
       {
        src: p17,
        source: p17,
        rows: 1.7,
        cols: 2,
        },
        {
        src: p18,
        source: p18,
        rows: 1.7,
        cols: 2,
        },
         {
        src: p19,
        source: p19,
        rows: 1.7,
        cols: 2,
        },
       


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                Investiture Ceremony
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Date: Friday, 19 June 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
National Public School, Yeshwanthpur, proudly conducted its Investiture Ceremony 2026
on Friday, 19 June, to formally induct the newly elected members of the Student Council,
House Captains, Discipline Committee and representatives of various clubs and
associations. The occasion was marked by grace, enthusiasm and a strong sense of
responsibility.                                    <br></br>
The ceremony began with an impressive march-past led by the student leaders. Dressed
smartly in their uniforms and carrying their respective house flags, the participants
demonstrated exceptional discipline, confidence and teamwork, creating a fitting
atmosphere for the event.
 <br></br>
 The Principal, Vice-Principal, Assistant Principals and Coordinators ceremonially presented
badges, sashes and flags to the newly appointed office bearers, symbolizing the transfer
of leadership responsibilities. The School Prefect administered the oath to the newly
appointed leaders and in her acceptance speech, expressed gratitude for the trust placed
in them, pledging to serve the school community with dedication and integrity.
 <br></br>
 Addressing the assembly, the School Principal Ms Sheeja Manoj congratulated the newly
elected leaders and were advised on three key points; firstly that that these positions and
badges has been entrusted to them in recognition of their capabilities and how they
have emerged, evolved and arrived to showcase the best notions of themselves to serve
the common expectation and urged them to shoulder their responsibilities along with the
teachers for the smooth functioning of the school. Secondly Leadership is a responsibility
and it must be discharged with mindfulness and humility and does not give the right to
belittle anybody. Thirdly, a leader should exemplify the best version of a human being by
moulding themselves as a person and standing by the same version of themselves and the
same values at all points of time. Encouraging them to uphold the values of the
institution, she urged the young leaders to support each other and cooperate to discharge
their duties effectively. The ceremony concluded with a sense of accomplishment and a
renewed determination among the student leaders to carry out their duties with diligence
and pride.

                                   
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “A leader is one who knows the way, goes the way and shows the way.”
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Investiture2026;